const host = process.env.VUE_APP_CURRENTMODE;
// const proUrl = "http://47.93.36.249:8050"; //线上地址
// const proUrl = "https://legalxchain.com"; //线上地址
const proUrl="http://59.110.150.162:8050";//测试环境平台
const local = "http://localhost:8050" //本地地址
let url = host == 'production' ? proUrl : local;
let downloadUrl = 'http://127.0.0.1:9050';
//证据预览下载
var downloadFile=[{
      partnerId:"1",
      ip:"https://www.ip360.net.cn/extractEvidence"//ip360
    },{
      partnerId:"2",
      ip:"http://www.netnotary.cn/extractEvidence"//杭互
    },{
      partnerId:"3",
      ip:"http://39.97.24.239:9060/extractEvidence"//广州
    },{
      partnerId:"4",
      ip:"http://39.107.110.94:9060/extractEvidence"//内蒙
    },{
      partnerId:"5",
      ip:"http://47.94.206.203:9060/extractEvidence"//方正
    },{
      partnerId:"6",
      ip:"http://121.43.13.193:9060/extractEvidence"//华东
    },{
      partnerId:"7",
      ip:"http://47.99.55.172:9060/extractEvidence"//渤海
    },{
      partnerId:"8",
      ip:"http://47.95.219.184:9060/extractEvidence"//佛山
    },{
      partnerId:"10",
      ip:"http://47.94.101.15:9060/extractEvidence"//精诚
    },{
      partnerId:"11",
      ip:"http://123.56.171.46:9060/extractEvidence"//方圆
    },{
      partnerId:"10",
      ip:"https://jcyunzheng.com/extractEvidence"//精诚
    },{
      partnerId:"11",
      ip:"https://www.bjnetnotary.com/extractEvidence"//方圆
    },{
      partnerId:"12",
      ip:"http://39.107.112.29:9060/extractEvidence"//国力
    },{
      partnerId:"13",
      ip:"https://bq.gz-notary.com/extractEvidence"//广州公证处
    },{
      partnerId:"15",
      ip:"https://huawei.ip360.org/extractEvidence"//IP360华为云
    },{
      partnerId:"16",
      ip:"https://www.cxnetnotary.com/extractEvidence"//辰信
    },{
      partnerId:"21",
      ip:"https://hec.ip360.org/extractEvidence"//上海东方
    },{
      partnerId:"25",
      ip:"http://120.46.83.217/extractEvidence"//河南
    },{
      partnerId:"29",
      ip:"https://hzzjgzy.cn/extractEvidence"//之江
    }]
 //过程取证附件下载
var downloadFjFile=[{
      partnerId:"1",
      ip:"https://www.ip360.net.cn"//ip360
    },{
      partnerId:"2",
      ip:"http://www.netnotary.cn"//杭互
    },{
      partnerId:"3",
      ip:"http://39.97.24.239:9060"//广州
    },{
      partnerId:"4",
      ip:"http://39.107.110.94:9060"//内蒙
    },{
      partnerId:"5",
      ip:"http://47.94.206.203:9060"//方正
    },{
      partnerId:"6",
      ip:"http://121.43.13.193:9060"//华东
    },{
      partnerId:"7",
      ip:"http://47.99.55.172:9060"//渤海
    },{
      partnerId:"8",
      ip:"http://47.95.219.184:9060"//佛山
    },{
      partnerId:"10",
      ip:"http://47.94.101.15:9060"//佛山
    },{
      partnerId:"11",
      ip:"http://123.56.171.46:9060"//方圆
    },{
      partnerId:"12",
      ip:"http://39.107.112.29:9060"//国力
    },{
      partnerId:"13",
      ip:"https://bq.gz-notary.com"//广州公证处
    },{
      partnerId:"15",
      ip:"https://huawei.ip360.org"//IP360华为云
    },{
      partnerId:"16",
      ip:"https://www.cxnetnotary.com"//辰信
    },{
      partnerId:"21",
      ip:"https://hec.ip360.org"//上海东方
    },{
      partnerId:"25",
      ip:"http://120.46.83.217"//河南
    },{
      partnerId:"29",
      ip:"https://hzzjgzy.cn"//之江
    }]
    //证据库下载
var downloadPack=[{
      partnerId:"1",
      ip:"http://47.93.45.188/ip360FileSource"//ip360
    },{
      partnerId:"2",
      ip:"http://47.93.45.188/qtFileSource"//杭互
    },{
      partnerId:"3",
      ip:"http://47.93.45.188/gzFileSource"//广州
    },{
      partnerId:"4",
      ip:"http://39.107.110.94/nmFileSource"//内蒙
    },{
      partnerId:"5",
      ip:"http://47.94.206.203/fzFileSource"//方正
    },{
      partnerId:"6",
      ip:"http://112.124.203.132/wzFileSource"//华东
    },{
      partnerId:"7",
      ip:"http://47.99.55.172/fzFileSource"//渤海
    }]
// var docUrl=[{
//   partnerId:"1",
//   ip:"http://59.110.150.162:8080"
// },{
//   partnerId:"2",
//   ip:"http://39.97.194.54"
// }]
var GlobalConfig = {
  downloadFile:downloadFile,//证据预览下载
  downloadPack:downloadPack,//保存
  downloadFjFile:downloadFjFile,//附件下载
  // webApiServerTest:"http://192.168.0.119:9060",//永光本地
  webApiServerTest:"http://127.0.0.1:9050",//测试环境
  webApiServer: url,
  socketIo: "http://59.110.149.218:50000", //websocket地址公网
  httpsSocketIo: "https://www.legalxchain.com",
  downloadpdf: downloadUrl, //下载pdf
  faceUrl:"https://www.ip360.net.cn"
}
export default GlobalConfig;
